<template>
    <p style="text-align: right">
        <a-space>
            <a-button @click="addCode" type="primary">
                <PlusOutlined/>
            </a-button>
            <a-button @click="getCodes">
                <RedoOutlined/>
            </a-button>
        </a-space>
    </p>
    <a-table
            size="small" :data-source="dataSource" :columns="columns" :loading="loadingAdmin"
            :scroll="{x: 'auto'}"
            :pagination="{
                showTotal: (total) => '共 ' + total,
                total: total_records,
                onChange: handlePageChange
            }"

    >
        <template #filterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
            <div style="padding: 8px">
                <a-input
                        ref="searchInput"
                        :placeholder="`搜索 ${column.title}`"
                        :value="selectedKeys[0]"
                        style="width: 188px; margin-bottom: 8px; display: block"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)"
                />
                <a-button
                        type="primary"
                        size="small"
                        style="width: 90px; margin-right: 8px"
                        @click="handleSearch(selectedKeys, confirm, column.dataIndex)"
                >
                    <template #icon><SearchOutlined /></template>
                    确认
                </a-button>
                <a-button size="small" style="width: 90px" @click="handleReset(clearFilters)">
                    重置
                </a-button>
            </div>
        </template>

        <template #points="{ record }">
                    <span>
                        <a-typography-text :type="record.points > 0? 'success': 'danger'">
                            {{record.points}}
                        </a-typography-text>
                      </span>
        </template>
        <template #charge="{ record }">
            <a-button shape="circle" @click="()=>handleCharge(record)" type="primary" ghost size="small">
                <template #icon>
                    <PlusOutlined/>
                </template>
            </a-button>
        </template>
        <template #status="{ record }">
            <a-popconfirm
                    v-if="record.status === 0"
                    title="确定废弃这个状态码吗"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="()=>handleVoid(record.coupon_code)"
                    @cancel="cancelVoid"
            >
                <a-tag color="blue" style="cursor: pointer">已创建</a-tag>
            </a-popconfirm>

            <a-tag color="green" v-if="record.status === 1">已核销</a-tag>
            <a-tag typa="error" v-if="record.status === -1">已废弃</a-tag>
        </template>
        <template #valid="{ record }">
            <a-tag color="red" v-if="isInvaid(record)">是</a-tag>
            <a-tag color="green" v-else>否</a-tag>
        </template>
        <template #action="{ record }">
            <span v-if="!isPhone">
                <a @click="()=>handleDetail(record)"><EyeOutlined/></a>
                <a-divider type="vertical"/>
            </span>
            <a @click="()=>handleShare(record)" v-if="record.status === 0"><ShareAltOutlined/></a>
            <span v-else style="color: #e8e8e8"><ShareAltOutlined/></span>
        </template>
    </a-table>
    <a-modal
            v-model:visible="visibleCode" title="创建兑换码"
            ok-text="确认"
            cancel-text="取消"
            @ok="handleOk"
            @cancel="handleCancel"
    >
        <a-divider/>
        <a-form :label-col="{span: 6}">
            <a-form-item label="积分">
                <a-radio-group
                        v-model:value="formState.points"
                        :options="[
                    {label: 2000, value: 2000},
                    {label: 5000, value: 5000},
                    {label: 10000, value: 10000},
                    ]"
                >
                    <a-radio value="1">Sponsor</a-radio>
                    <a-radio value="2">Venue</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="有效期起始日">
                <a-date-picker
                        v-model:value="formState.valid_start_date "
                        type="date"
                        placeholder="请选择日期"
                />
            </a-form-item>
            <a-form-item label="有效天数">
                <a-input-number v-model:value="formState.valid_days" :min="1" :step="1"/>
            </a-form-item>
            <a-form-item label="手机号">
                <a-input v-model:value="formState.tel"/>
            </a-form-item>
            <a-form-item label="赠送人称呼">
                <a-input v-model:value="formState.presenter " placeholder="如：您的好友xxx"/>
            </a-form-item>
            <a-form-item label="备注">
                <a-input v-model:value="formState.comment "/>
            </a-form-item>
        </a-form>
        <a-divider/>
    </a-modal>

        <a-modal id="card2" v-model:open="openQRCode"
                 wrap-class-name="coupon-qrcode"
                 style="width: 320px;"
                 :footer="null"
        >
            <div>
                <div id="card" style="padding: 0 25px 10px;">
                    <CouponQrcode :data="shareRecord"/>
                </div>
                <p style="text-align: right; padding-right: 25px;">
                    <a-space>
                <span class="circle" id="copy" v-if="!isPhone">
                    <CopyOutlined @click="copyImg"/>
                </span>
                        <span class="circle">
                    <DownloadOutlined @click="generateImg"/>
                </span>
                    </a-space>
                </p>
            </div>
        </a-modal>

    <img v-if="imgData" :src="'data:image/png;base64,' + imgData" alt="" width="100" id="imageElement">
    <a-modal v-model:open="openDetail" :footer="null">
        <p>
            <b>[{{detailRecord.no}}].兑换码</b>: {{detailRecord.coupon_code}} <CouponStatus :record="detailRecord"/>
        </p>

        <p>
            {{detailRecord.account}} 于 {{detailRecord.add_time}} 创建，积分为：{{detailRecord.points}}.
            <span v-if="detailRecord.bind_account">
            {{detailRecord.bind_account}} 于 {{detailRecord.bind_time}}核销.
        </span>
        </p>
        <p>
                <span>有效期:</span> {{detailRecord.valid_start_date}} ~ {{detailRecord.valid_end_date}}，
                <span>有效天数:</span> {{detailRecord.valid_days}}.
        </p>
        <template v-for="(detailItem, k) in detailItems" :key="k">
            <p><span>{{detailItem.title}}</span>:
                <span>
                {{detailRecord[detailItem.key] || '暂无'}}
                </span>
            </p>
        </template>

        <p>
            <span>备注</span>: {{detailRecord.comment}}
        </p>
    </a-modal>
    <!-- 降级方案容器：初始隐藏，仅在需要时显示 -->
    <div id="fallbackBox" style="display: none; border: 1px dashed #ccc; padding: 15px; margin-top: 15px; text-align: center;">
        <!-- 里面的内容将由JavaScript动态生成 -->
    </div>
</template>

<script setup>
    // import moment from 'moment';
    import {
        PlusOutlined, SearchOutlined, RedoOutlined, EyeOutlined, ShareAltOutlined,
        CopyOutlined, DownloadOutlined
    } from '@ant-design/icons-vue';
    import {onMounted, ref} from 'vue';
    import CouponQrcode from "./CouponQrcode";
    import CouponStatus from "./CouponStatus";
    import {isPhone} from "../../utils/llm.tools";
    import {
        get_biogpt_admin_points_coupon_record,
        post_biogpt_admin_points_coupon, post_biogpt_admin_points_coupon_void
    } from "../../utils/bioinfo.api";
    import {jy_tip, exportAsImage, downImg,
        copyImageToClipboard
    } from "@/utils/vue.tool";
    import {compare, isDEV} from "../../utils/request";
    import {getAccount} from "../../utils/llm.tools";
    // import ImageCopyHandler from "../../utils/copyImg";
    let dataSource = ref([]);
    let loadingAdmin = ref(true);
    let visible = ref(false);
    let visibleCode = ref(false);
    let activeRecord = ref(undefined);
    const dateFormat = 'YYYY-MM-DD';
    // let today = moment(new Date(), dateFormat);
    let account = getAccount();
    let formState = ref({
        points: 2000,
        // valid_start_date: today,
        valid_days: 30,
        presenter: '好友' + account,
    });
    let state = ref({
        searchText: '',
        searchedColumn: ''
    });
    let page = ref(1);
    let total_records = ref(0);
    //no 编号
    // coupon_code
    // points
    // account
    // bind_account
    // bind_time
    // status
    // 是否超期

    let columns = [
        {
            title: 'No', dataIndex: 'no',
            sorter: compare('no')
        },
        {
            title: '兑换码', dataIndex: 'coupon_code',
            sorter: compare('coupon_code')
        },
        {title: '积分', dataIndex: 'points', slots: { customRender: 'points' }, sorter: compare('points')},
        {title: '核销时间', dataIndex: 'bind_time', sorter: compare('bind_time')},
        {
            title: '创建者', dataIndex: 'account',
            slots: { title: 'user', filterDropdown: 'filterDropdown', },
            onFilter: (value, record) =>
                record.account.toString().toLowerCase().includes(value.toLowerCase()),
            sorter: compare('account')
        },

        {title: '状态', dataIndex: 'status', slots: { customRender: 'status' }},
        {title: '核销用户', dataIndex: 'bind_account', sorter: compare('bind_account')},
        {title: '是否超期', dataIndex: 'valid', slots: {customRender: 'valid' }},
        {title: '操作', dataIndex: 'action', slots: {customRender: 'action' }, fixed: 'right',},
    ];
    onMounted(()=>{
        getCodes();
    });
    const getCodes = ()=>{
        loadingAdmin.value = true;
        get_biogpt_admin_points_coupon_record({page: page.value}, (res)=>{
            let {data, message} = res;
            loadingAdmin.value = false;
            if(data){
                dataSource.value = data;
                total_records.value = res?.total_records;
            }
            else {
                jy_tip('获取兑换码记录失败：' + message);
            }
        })
    };
    const addCode = ()=> visibleCode.value = true;
    const handleCharge = (record)=>{
        activeRecord.value = record;
        visible.value = true;
    };
    const handleOk = () => {
        let rq = formState.value;
        let {valid_start_date } = rq;
        try {
            rq.valid_start_date = valid_start_date.format(dateFormat);
        } catch (e) {
            console.log(e);
        }

        if(isDEV) console.log('valid_start_date', rq.valid_start_date);
        post_biogpt_admin_points_coupon(rq, (res)=>{
            let {message, status} = res;
            if(status === 1000001){
                jy_tip('兑换码['+res.data.coupon_code+']已创建', 'success');
                getCodes();
                visibleCode.value = false;
            }else jy_tip('兑换码创建失败：' + message);
        })
    };
    const handleCancel = ()=>{
        visibleCode.value = false;
    };
    const isInvaid = (record)=>{
        let {valid_start_date, valid_days} = record;
        const date1 = new Date(valid_start_date);
        const date2 = new Date();
        const diffTime = Math.abs(date2 - date1); // 绝对值，总是正数
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        console.log(diffDays); // 输出：1
        return (diffDays > valid_days);
    };
    const handleVoid = (coupon_code)=>{
        post_biogpt_admin_points_coupon_void({coupon_code}, (res)=>{
            let {status, message} = res;
            if(status === 403) jy_tip('您没有权限');
            else if(status === 4031) jy_tip('无效兑换码');
            else if(status === 1000001) {
                jy_tip('已废弃兑换码[' + coupon_code + ']', 'success');
                getCodes();
            }
            else jy_tip('废弃失败：' + message)

        })
    };
    let shareRecord = ref(null);
    let imgData = ref(null);
    let openQRCode = ref(false);
    const handleShare = (record)=>{
        shareRecord.value = record;
        openQRCode.value = true;
    };
    // const cancelShare = ()=>{
    //     shareRecord.value = null;
    //     openQRCode.value = false;
    // };
    let detailRecord = ref(null);
    let openDetail = ref(false);
    let detailItems = [

        {title: '赠送人称呼', key: 'presenter'},
        {title: '手机号', key: 'tel'},
    ];
    const handleDetail = (record)=>{
        detailRecord.value = record;
        openDetail.value = true;
    };

    const copyImg = async() => {
        // generateIm
        if(isPhone){
            // new ImageCopyHandler('VIPaper.png', 'copy', 'fallbackBox');
                if (navigator.share) {
                    // 使用Web Share API
                    alert('share');
                    try {
                        await navigator.share({
                            title: '分享图片',
                            text: '看看这张图片',
                            // files: [imageFile] // 注意：需要是File对象，且部分浏览器可能不支持files参数
                        });
                    } catch (err) {
                        // 用户取消了分享或分享失败，降级到方案A
                        // fallbackCopyMethod();
                        alert('失败');
                    }
                } else {
                    alert('不能分享')
                }
        }else {
            exportAsImage(document.getElementById('card'), (data)=>{
                imgData.value = data;
                copyImageToClipboard(data);
            });
        }
        // let cardEle = document.getElementById('card');

    };
    const generateImg = () => {
        // generateIm
        exportAsImage(document.getElementById('card'), (data)=>{
            imgData.value = data;
            downImg(data);
        })
    };
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        state.value.searchText = selectedKeys[0];
        state.value.searchedColumn = dataIndex;
    };

    const handleReset = clearFilters => {
        clearFilters();
        state.value.searchText = '';
    };
    const handlePageChange = (current)=>{
        page.value = current;
        console.log('current', current);
        getCodes();
    }

</script>
<style>


</style>